import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import type { PeriodSummary } from "@/pages/human-resources/time-management/business/analysis/PeriodSummary.ts";
import { useRecapTable } from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/recap-table/useRecapTable.ts";
import RecapTableCell from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/recap-table/RecapTableCell.tsx";
import "./RecapTable.scss";
import { PERIOD_SUMMARY_INDICATORS_KEYS } from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/model/PeriodSummaryIndicatorsList.ts";
import RecapTableHeader from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/recap-table/RecapTableHeader.tsx";

interface Props {
  summaryByMode: {
    PREVIOUS_YEAR: PeriodSummary;
    FORECAST: PeriodSummary;
    TREND: PeriodSummary;
  };
}

export default function DaySummaryRecapTable({
  summaryByMode,
}: Props): ReactElement {
  const { t } = useTranslation("humanResources");
  const { rows } = useRecapTable();

  return (
    <div className="day-summary-recap">
      <table className="recap-table">
        <thead>
          <tr>
            <th className="recap-header-mode" />
            {PERIOD_SUMMARY_INDICATORS_KEYS.map((indic) => (
              <RecapTableHeader key={indic} indicatorKey={indic} />
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => {
            const summary = summaryByMode[row.mode];
            return (
              <tr key={row.mode}>
                <td className="recap-mode-cell">
                  <row.Icon className="recap-mode-icon" />
                  <span className="recap-mode-label">{t(row.labelKey)}</span>
                </td>
                {PERIOD_SUMMARY_INDICATORS_KEYS.map((indic) => {
                  return (
                    <RecapTableCell
                      key={indic}
                      indicatorKey={indic}
                      summary={summary}
                    />
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
